﻿module SafeStack.Client.ValidationInfrastructure 

let bundleValidations getter count (validations: 'v list) =
        let accum = Array.init count (fun _ -> [])
        let addToAcc index str (acc: string list []) = 
            acc.[index] <- str::acc.[index]
            acc
        validations
        |> List.fold (fun acc v ->
            let index, str = getter v
            addToAcc index str acc
        ) accum
        |> Array.map Illy.SafeStack.CompositionalValidation.concatOptional 

let bundleValidationsAbstract getter count (validations: 'v list) =
        let accum = Array.init count (fun _ -> [])
        let addToAcc index str (acc: 'a list []) = 
            acc.[index] <- str::acc.[index]
            acc
        validations
        |> List.fold (fun acc v ->
            let index, str = getter v
            addToAcc index str acc
        ) accum   
        
let divideValidations2 (divider: 'a -> Choice<'b, 'c>) (vals: 'a list) : 'b list * 'c list =
    vals
    |> List.fold (fun (b, c) a -> 
        match divider a with
        | Choice1Of2 x -> x::b,c
        | Choice2Of2 x -> b,x::c
    ) ([],[])
    
let divideValidations3 (divider: 'a -> Choice<'b, 'c, 'd>) (vals: 'a list) : 'b list * 'c list * 'd list =
    vals
    |> List.fold (fun (b, c, d) a -> 
        match divider a with
        | Choice1Of3 x -> x::b,c,d
        | Choice2Of3 x -> b,x::c,d
        | Choice3Of3 x -> b,c,x::d  
    ) ([],[],[])

let divideValidations4 (divider: 'a -> Choice<'b, 'c, 'd, 'e>) (vals: 'a list) : 'b list * 'c list * 'd list * 'e list =
    vals
    |> List.fold (fun (b, c, d, e) a -> 
        match divider a with
        | Choice1Of4 x -> x::b,c,d,e
        | Choice2Of4 x -> b,x::c,d,e
        | Choice3Of4 x -> b,c,x::d,e
        | Choice4Of4 x -> b,c,d,x::e
    ) ([],[],[],[])           

let divideValidations5 (divider: 'a -> Choice<'b, 'c, 'd, 'e, 'f>) (vals: 'a list) : 'b list * 'c list * 'd list * 'e list * 'f list =
    vals
    |> List.fold (fun (b, c, d, e, f) a -> 
        match divider a with
        | Choice1Of5 x -> x::b,c,d,e,f
        | Choice2Of5 x -> b,x::c,d,e,f
        | Choice3Of5 x -> b,c,x::d,e,f
        | Choice4Of5 x -> b,c,d,x::e,f
        | Choice5Of5 x -> b,c,d,e,x::f
    ) ([],[],[],[],[])     

let divideValidations6 (divider: 'a -> Choice<'b, 'c, 'd, 'e, 'f, 'g>) (vals: 'a list) : 'b list * 'c list * 'd list * 'e list * 'f list * 'g list =
    vals
    |> List.fold (fun (b, c, d, e, f, g) a -> 
        match divider a with
        | Choice1Of6 x -> x::b,c,d,e,f,g
        | Choice2Of6 x -> b,x::c,d,e,f,g
        | Choice3Of6 x -> b,c,x::d,e,f,g
        | Choice4Of6 x -> b,c,d,x::e,f,g
        | Choice5Of6 x -> b,c,d,e,x::f,g
        | Choice6Of6 x -> b,c,d,e,f,x::g
    ) ([],[],[],[],[],[])  

let divideValidations7 (divider: 'a -> Choice<'b, 'c, 'd, 'e, 'f, 'g, 'h>) (vals: 'a list) : 'b list * 'c list * 'd list * 'e list * 'f list * 'g list * 'h list =
    vals
    |> List.fold (fun (b, c, d, e, f, g, h) a -> 
        match divider a with
        | Choice1Of7 x -> x::b,c,d,e,f,g,h
        | Choice2Of7 x -> b,x::c,d,e,f,g,h
        | Choice3Of7 x -> b,c,x::d,e,f,g,h
        | Choice4Of7 x -> b,c,d,x::e,f,g,h
        | Choice5Of7 x -> b,c,d,e,x::f,g,h
        | Choice6Of7 x -> b,c,d,e,f,x::g,h
        | Choice7Of7 x -> b,c,d,e,f,g,x::h
    ) ([],[],[],[],[],[],[])   

[<StructuralEquality; StructuralComparison>]
[<CompiledName("FSharpChoice`8")>]
type Choice<'T1,'T2,'T3,'T4,'T5,'T6,'T7,'T8> = 
    | Choice1Of8 of 'T1
    | Choice2Of8 of 'T2
    | Choice3Of8 of 'T3
    | Choice4Of8 of 'T4
    | Choice5Of8 of 'T5
    | Choice6Of8 of 'T6
    | Choice7Of8 of 'T7
    | Choice8Of8 of 'T8

[<StructuralEquality; StructuralComparison>]
[<CompiledName("FSharpChoice`9")>]
type Choice<'T1,'T2,'T3,'T4,'T5,'T6,'T7,'T8,'T9> = 
    | Choice1Of9 of 'T1
    | Choice2Of9 of 'T2
    | Choice3Of9 of 'T3
    | Choice4Of9 of 'T4
    | Choice5Of9 of 'T5
    | Choice6Of9 of 'T6
    | Choice7Of9 of 'T7
    | Choice8Of9 of 'T8
    | Choice9Of9 of 'T9

[<StructuralEquality; StructuralComparison>]
[<CompiledName("FSharpChoice`10")>]
type Choice<'T1,'T2,'T3,'T4,'T5,'T6,'T7,'T8,'T9, 'T10> = 
    | Choice1Of10 of 'T1
    | Choice2Of10 of 'T2
    | Choice3Of10 of 'T3
    | Choice4Of10 of 'T4
    | Choice5Of10 of 'T5
    | Choice6Of10 of 'T6
    | Choice7Of10 of 'T7
    | Choice8Of10 of 'T8
    | Choice9Of10 of 'T9
    | Choice10Of10 of 'T10


let divideValidations8 (divider: 'a -> Choice<'b, 'c, 'd, 'e, 'f, 'g, 'h, 'i>) (vals: 'a list) : 'b list * 'c list * 'd list * 'e list * 'f list * 'g list * 'h list * 'i list =
    vals
    |> List.fold (fun (b, c, d, e, f, g, h, i) a -> 
        match divider a with
        | Choice1Of8 x -> x::b,c,d,e,f,g,h,i
        | Choice2Of8 x -> b,x::c,d,e,f,g,h,i
        | Choice3Of8 x -> b,c,x::d,e,f,g,h,i
        | Choice4Of8 x -> b,c,d,x::e,f,g,h,i
        | Choice5Of8 x -> b,c,d,e,x::f,g,h,i
        | Choice6Of8 x -> b,c,d,e,f,x::g,h,i
        | Choice7Of8 x -> b,c,d,e,f,g,x::h,i
        | Choice8Of8 x -> b,c,d,e,f,g,h,x::i
    ) ([],[],[],[],[],[],[],[])    

let divideValidations9 (divider: 'a -> Choice<'b, 'c, 'd, 'e, 'f, 'g, 'h, 'i, 'j>) (vals: 'a list) : 'b list * 'c list * 'd list * 'e list * 'f list * 'g list * 'h list * 'i list * 'j list =
    vals
    |> List.fold (fun (b, c, d, e, f, g, h, i, j) a -> 
        match divider a with
        | Choice1Of9 x -> x::b,c,d,e,f,g,h,i,j
        | Choice2Of9 x -> b,x::c,d,e,f,g,h,i,j
        | Choice3Of9 x -> b,c,x::d,e,f,g,h,i,j
        | Choice4Of9 x -> b,c,d,x::e,f,g,h,i,j
        | Choice5Of9 x -> b,c,d,e,x::f,g,h,i,j
        | Choice6Of9 x -> b,c,d,e,f,x::g,h,i,j
        | Choice7Of9 x -> b,c,d,e,f,g,x::h,i,j
        | Choice8Of9 x -> b,c,d,e,f,g,h,x::i,j
        | Choice9Of9 x -> b,c,d,e,f,g,h,i,x::j
    ) ([],[],[],[],[],[],[],[],[])       

let divideValidations10 (divider: 'a -> Choice<'b, 'c, 'd, 'e, 'f, 'g, 'h, 'i, 'j, 'k>) (vals: 'a list) : 'b list * 'c list * 'd list * 'e list * 'f list * 'g list * 'h list * 'i list * 'j list * 'k list =
    vals
    |> List.fold (fun (b, c, d, e, f, g, h, i, j, k) a -> 
        match divider a with
        | Choice1Of10 x -> x::b,c,d,e,f,g,h,i,j,k
        | Choice2Of10 x -> b,x::c,d,e,f,g,h,i,j,k
        | Choice3Of10 x -> b,c,x::d,e,f,g,h,i,j,k
        | Choice4Of10 x -> b,c,d,x::e,f,g,h,i,j,k
        | Choice5Of10 x -> b,c,d,e,x::f,g,h,i,j,k
        | Choice6Of10 x -> b,c,d,e,f,x::g,h,i,j,k
        | Choice7Of10 x -> b,c,d,e,f,g,x::h,i,j,k
        | Choice8Of10 x -> b,c,d,e,f,g,h,x::i,j,k
        | Choice9Of10 x -> b,c,d,e,f,g,h,i,x::j,k
        | Choice10Of10 x -> b,c,d,e,f,g,h,i,j,x::k
    ) ([],[],[],[],[],[],[],[],[],[])       

